import { useCallback, useState } from "react"
import { toast } from "react-toastify";
import { globalAxios } from "../services/globalAxios"
import { AxiosRequestConfig } from "axios";
import { toastError, toastSuccess } from "../components/assets/customToasts";

type MaybeAsyncFn = () => void | Promise<void>

type useDeleteParams = {
    onSuccess?: MaybeAsyncFn
    onError?: MaybeAsyncFn
    onSettled?: MaybeAsyncFn
}

type useDeleteType = {
    handleDelete: (url: string, config?: AxiosRequestConfig) => Promise<void>
    isHandlingDelete: boolean
    response: any
    setResponse: React.Dispatch<React.SetStateAction<any>>
}

export default function useDelete({
    onSuccess,
    onError,
    onSettled,
    useToast
}: useDeleteParams & { useToast?: boolean }): useDeleteType {

    const [isHandlingDelete, setIsHandlingDelete] = useState(false)
    const [response, setResponse] = useState<any>(null)

    const handleDelete = useCallback(async (url: string, config: AxiosRequestConfig = {}) => {
        console.log('Deleting:', url)
        setIsHandlingDelete(true)
        let _toast: any = null
        if (useToast !== false) {
            _toast = toast('Deleting data...', { toastId: 'toast-delete', isLoading: true })
        }
        try {
            const res = await globalAxios.delete(url, config)
            setResponse(res.data)
            await onSuccess?.()
            useToast !== false && toastSuccess(_toast, 'Successfully deleted.')
        } catch (error) {
            await onError?.()
            console.log(error)
            useToast !== false && toastError(_toast, 'Could not delete data.')
        } finally {
            setIsHandlingDelete(false)
            await onSettled?.()
            if (_toast) toast.dismiss(_toast)
        }
    }, [onSuccess, onError, onSettled, useToast])

    return { handleDelete, isHandlingDelete, response, setResponse }
}